
import { postRequest, getRequest } from "../utils/HttpRequest";
import { CONFIG } from "../config";

const API_ENDPOINTS = CONFIG.endPoints;


const getModels = async (params = {}) => {
    try {

        const response = await getRequest(API_ENDPOINTS["get-models"], params);
        return response;

    } catch (err) {
        let error = err.response ? err.response.data : err;
        throw error
    }

}



const postMsg = async (params) => {
    try {
        const response = await postRequest(API_ENDPOINTS["post-msg"], params);
        return response;
    } catch (err) {
        let error = err.response ? err.response.data : err;
        throw error
    }
}

const getThemeObject = async (domain) => {
    try {
        const response = await getRequest(API_ENDPOINTS["get-theme"] + `/${domain}`, {});
        return response;
    } catch (err) {
        let error = err.response ? err.response.data : err;
        throw error
    }
}

const getFunctionDefintion = async (name) => {
    try {
        const response = await getRequest(API_ENDPOINTS["get-function"] + `/${name}`, {});
        return response;
    } catch (err) {
        let error = err.response ? err.response.data : err;
        throw error
    }
}


export {
    getModels,
    postMsg,
    getThemeObject,
    getFunctionDefintion,
    

}

